import { AdMob, AdOptions } from '@capacitor-community/admob';
import { Capacitor } from '@capacitor/core';

const INTERSTITIAL_AD_ID_ANDROID = 'ca-app-pub-3345494637413521/8380976521';
const INTERSTITIAL_AD_ID_IOS = 'ca-app-pub-3345494637413521/6389707197';

// テスト広告ID（開発時に使用）
// const INTERSTITIAL_AD_ID_ANDROID = 'ca-app-pub-3940256099942544/1033173712';
// const INTERSTITIAL_AD_ID_IOS = 'ca-app-pub-3940256099942544/4411468910';

const INTERSTITIAL_AD_ID =
  Capacitor.getPlatform() === 'ios' ? INTERSTITIAL_AD_ID_IOS : INTERSTITIAL_AD_ID_ANDROID;

let initialized = false;
let interstitialBattleCount = 0;
const INTERSTITIAL_INTERVAL = 5;

/** AdMobを初期化 */
export async function initAdMob(): Promise<void> {
  if (initialized) return;
  try {
    await AdMob.initialize();
    initialized = true;
  } catch (e) {
    // ネイティブ環境以外（Web）では無視
  }
}

/** インタースティシャル広告を表示（5回に1回） */
export async function showInterstitialIfNeeded(): Promise<void> {
  if (!initialized) return;
  interstitialBattleCount++;
  if (interstitialBattleCount < INTERSTITIAL_INTERVAL) return;
  interstitialBattleCount = 0;

  try {
    const options: AdOptions = { adId: INTERSTITIAL_AD_ID };
    await AdMob.prepareInterstitial(options);
    await AdMob.showInterstitial();
  } catch (e) {
    // 無視
  }
}
